import { OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import BaseFacet from '../BaseFacet/BaseFacet';
import FacetType from '../../../utility/types/facetType';
import { facetTypeDetails } from '../../../utility/types/facetTypeDetails';
import SearchType from '../../../utility/types/SearchType';

class PushStatusFacet extends BaseFacet {
  constructor() {
    super();
    this.facetType = FacetType.PUSH_STATUS;
    this.displayName = 'Push Status';
    this.description = 'Include alerts on sensors with the status of...';
  }

  getDescription(searchType) {
    if (searchType === SearchType.DEVICE) {
      return 'Include devices with the status of...';
    }
    return this.description;
  }

  // eslint-disable-next-line class-methods-use-this
  getOperatorDescription(operatorType) {
    const operatorTypeId = parseInt(operatorType, 10);
    const operatorDescriptions = {
      [OperatorTypes.EQUAL_TO_VALUE]: 'Pushing',
      [OperatorTypes.NOT_EQUAL_TO]: 'Not Pushing',
    };
    return operatorDescriptions[operatorTypeId] || '';
  }

  // eslint-disable-next-line class-methods-use-this
  getDisplayValue1() {
    return '';
  }

  getOperatorSelectOptions() {
    const facet = facetTypeDetails[this.facetType];
    return [
      {
        value: facet.validOperators[0],
        label: this.getOperatorDescription(facet.validOperators[0]),
      },
      {
        value: facet.validOperators[1],
        label: this.getOperatorDescription(facet.validOperators[1]),
      },
    ];
  }

  // eslint-disable-next-line class-methods-use-this
  getTooltip(filtersByOperatorObj, searchType) {
    if (filtersByOperatorObj && Object.values(filtersByOperatorObj).length) {
      const filtersArray = Object.values(filtersByOperatorObj)[0];
      const filter = filtersArray[0];
      return `${searchType === SearchType.ALERT ? 'Alert' : 'Device'} is ${this.getOperatorDescription(filter.operatorId)}`;
    }
    return '';
  }
}
export default PushStatusFacet;
